import React from 'react';


const MKTEXITINTENTTEMP4 = ({ formData, entityBrandingUrl, sourceDomain, poweredByIcon, absoluteURL }) => {
  const handleClose = () => {
    const element = document.getElementsByClassName('MKTEXITINTENTTEMP4')[0];
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  };

  return (
    <div>
      <div className="MKTEXITINTENTTEMP4">
        <div 
          className={`mkt-animated ${formData?.actionProps?.emailSubscriptionForm?.animation}`}
          id="MKTEXITINTENTTEMP4"
        >
          <div id="exit-intent-template">
            <div 
              className="border-modal5"
              style={{ 
                borderColor: formData?.actionProps?.emailSubscriptionForm?.confirmButton?.background?.color 
              }}
            >
              <a 
                className="mkt-close-exit-intent mkt-close-2-icon cancel-button" 
                id="close-frame"
                onClick={handleClose}
              />

              <div className="exit-intent-template language-handler">
                <div 
                  id="exit-intent-template5"
                  style={{ 
                    background: formData?.actionProps?.emailSubscriptionForm?.background?.color 
                  }}
                >
                  {formData?.actionProps?.emailSubscriptionForm?.logo?.show && (
                    <div 
                      className="mkt-logo-container"
                      style={{ 
                        textAlign: formData?.actionProps?.emailSubscriptionForm?.logo?.position 
                      }}
                    >
                      <img 
                        src={formData?.actionProps?.emailSubscriptionForm?.logo?.url} 
                        alt="logo" 
                      />
                    </div>
                  )}

                  <div className="exit-intent-title">
                    <span
                      style={{
                        lineHeight: 'normal',
                        fontSize: formData?.actionProps?.emailSubscriptionForm?.heading?.fontsize,
                        color: formData?.actionProps?.emailSubscriptionForm?.heading?.color
                      }}
                      dangerouslySetInnerHTML={{ 
                        __html: formData?.actionProps?.emailSubscriptionForm?.heading?.text 
                      }}
                    />
                  </div>

                  <div className="exit-intent-desc">
                    <span
                      style={{
                        lineHeight: 'normal',
                        fontSize: formData?.actionProps?.emailSubscriptionForm?.subheading?.fontsize,
                        color: formData?.actionProps?.emailSubscriptionForm?.subheading?.color
                      }}
                      dangerouslySetInnerHTML={{ 
                        __html: formData?.actionProps?.emailSubscriptionForm?.subheading?.text 
                      }}
                    />
                  </div>

                  <div className="template-inputs">
                    <form autoComplete="off" id="ft_exit_intent_template_form">
                      {formData?.actionProps?.emailSubscriptionForm?.overlayfields?.email && (
                        <input
                          id="ftExitIntentEmailField"
                          name="email"
                          placeholder="Enter email address"
                          type="email"
                        />
                      )}
                      <span className="exitintent-error-block" />

                      {formData?.actionProps?.emailSubscriptionForm?.overlayfields?.phone && (
                        <input
                          id="ftExitIntentPhoneField"
                          name="phone"
                          placeholder="Enter phone number"
                          type="text"
                        />
                      )}
                      <span className="exitintent-error-block" />
                    </form>
                  </div>

                  {formData?.actionProps?.emailSubscriptionForm?.consentMsg?.status && (
                    <p
                      className="mkt-consent-text"
                      style={{
                        color: formData?.actionProps?.emailSubscriptionForm?.consentMsg?.color,
                        lineHeight: 'normal',
                        fontSize: formData?.actionProps?.emailSubscriptionForm?.consentMsg?.fontsize,
                        marginTop: '5px',
                        padding: 0
                      }}
                      dangerouslySetInnerHTML={{ 
                        __html: formData?.actionProps?.emailSubscriptionForm?.consentMsg?.text 
                      }}
                    />
                  )}

                  <div className="buttons-container">
                    <button
                      className="yes-btn"
                      id="ft_exit_intent_template_submit"
                      style={{ 
                        background: formData?.actionProps?.emailSubscriptionForm?.confirmButton?.background?.color 
                      }}
                      type="submit"
                    >
                      <span>
                        <span
                          style={{ 
                            color: formData?.actionProps?.emailSubscriptionForm?.confirmButton?.color 
                          }}
                          dangerouslySetInnerHTML={{ 
                            __html: formData?.actionProps?.emailSubscriptionForm?.confirmButton?.text 
                          }}
                        />
                      </span>
                    </button>

                    <button
                      className="no-btn cancel-button"
                      onClick={handleClose}
                      style={{ 
                        background: formData?.actionProps?.emailSubscriptionForm?.cancelButton?.background?.color 
                      }}
                    >
                      <span>
                        <span
                          style={{ 
                            color: formData?.actionProps?.emailSubscriptionForm?.cancelButton?.color 
                          }}
                          dangerouslySetInnerHTML={{ 
                            __html: formData?.actionProps?.emailSubscriptionForm?.cancelButton?.text 
                          }}
                        />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div 
              style={{ 
                width: '100%', 
                padding: '10px 0', 
                textAlign: 'center', 
                position: 'absolute', 
                bottom: '-44px', 
                filter: 'brightness(100)' 
              }}
            >
              {/* {exitIntentBranding && (
                <a
                  className="dialog-branding-text"
                  href={`${entityBrandingUrl}?utm_source=${sourceDomain}&utm_medium=exitintent&utm_campaign=poweredby`}
                  target="_blank"
                >
                  Powered by
                  <img 
                    style={{ width: 'auto', height: '15px', marginLeft: '10px' }} 
                    src={poweredByIcon} 
                    alt="branding" 
                  />
                </a>
              )} */}
            </div>
          </div>

          <div 
            className="mkt-overlay-container cancel-button"
            onClick={() => {
              const element = document.getElementsByClassName('MKTEXITINTENTTEMP1')[0];
              if (element?.parentNode) element.parentNode.removeChild(element);
            }}
          />

          <img 
            id="ft-exit-intent-empty-image" 
            src={`${process.env.REACT_APP_API_ENDPOINT}/assets/img/emptyImage.jpg`}
            alt="empty" 
          />
        </div>
      </div>
    </div>
  );
};

export default MKTEXITINTENTTEMP4;